import { mergeTemplate } from './base-template';

export const handwerkerTemplate = mergeTemplate({
  name: 'Handwerker',
  icon: '🔨',
  settings: {
    primaryColor: '#c2410c',
    accentColor: '#fbbf24',
    fontStack: 'dmsans',
    pageAngebot: {
      heroTitle: 'Unsere Leistungen & Preise',
      heroSubtitle: 'Qualität hat ihren Preis — Transparenz auch',
      packages: [
        { name: 'Kleinauftrag', price: 'ab CHF 500', description: 'Reparaturen und kleine Arbeiten', features: 'Vor-Ort-Analyse, Reparatur, Material, Aufräumen, 1 Jahr Garantie', highlighted: false },
        { name: 'Mittlerer Auftrag', price: "ab CHF 2'500", description: 'Renovationen und Umbauten', features: 'Planung, Ausführung, Koordination, Materialberatung, 2 Jahre Garantie', highlighted: true },
        { name: 'Grossauftrag', price: 'auf Anfrage', description: 'Neubauten und Komplettsanierungen', features: 'Komplettplanung, Bauleitung, Subunternehmer, Abnahme, 5 Jahre Garantie', highlighted: false },
      ],
      ctaTitle: 'Offerte gewünscht?',
      ctaText: 'Wir kommen vorbei, schauen uns die Situation an und machen Ihnen ein faires Angebot.',
      ctaButtonText: 'Kostenlose Besichtigung',
    },
    pageMethoden: {
      heroTitle: 'So arbeiten wir',
      heroSubtitle: 'Vom ersten Anruf bis zur sauberen Abnahme',
      introText: 'Handwerk ist Vertrauenssache. Deshalb arbeiten wir transparent, termingerecht und mit Liebe zum Detail.',
      steps: [
        { title: 'Besichtigung', description: 'Wir kommen vorbei und schauen uns die Situation vor Ort an' },
        { title: 'Offerte', description: 'Sie erhalten eine detaillierte, verbindliche Offerte — ohne versteckte Kosten' },
        { title: 'Ausführung', description: 'Fachgerechte Arbeit, saubere Baustelle, termingerechte Fertigstellung' },
        { title: 'Abnahme', description: 'Gemeinsame Kontrolle, Nacharbeiten wenn nötig, Übergabe mit Garantie' },
      ],
      tools: [
        { name: 'Professionelles Werkzeug', description: 'Aktueller Maschinenpark für präzise Ergebnisse' },
        { name: 'Digitale Offerten', description: 'Transparente Kalkulationen per E-Mail' },
        { name: 'Termintreue', description: 'Projektplanung mit verbindlichen Zeitfenstern' },
      ],
      philosophyTitle: 'Handwerk mit Herz',
      philosophyText: 'Wir machen keine halben Sachen. Jeder Auftrag wird so ausgeführt, als wäre es unser eigenes Zuhause.',
    },
    pageUeberMich: {
      heroTitle: 'Unser Betrieb',
      heroSubtitle: 'Meisterqualität aus der Region',
      introText: 'Seit drei Generationen steht unser Name für solides Handwerk, faire Preise und zufriedene Kunden.',
      imageUrl: '',
      timeline: [
        { year: '1985', text: 'Gründung als Einmannbetrieb' },
        { year: '2005', text: 'Erweiterung auf 8 Mitarbeitende' },
        { year: '2020', text: 'Modernisierung und Digitalisierung' },
      ],
      values: [
        { title: 'Qualität', description: 'Fachgerechte Arbeit mit besten Materialien' },
        { title: 'Zuverlässigkeit', description: 'Termine und Preise, auf die Sie sich verlassen können' },
        { title: 'Regionalität', description: 'Verwurzelt in der Region, kurze Wege, persönlicher Kontakt' },
      ],
      certifications: 'Eidg. Fachausweis, Meisterbetrieb, Suva-konform',
    },
  },
  components: {
    header: {
      companyName: 'Handwerk Muster',
      logoText: 'HM',
      navItems: ['Leistungen', 'Vorgehen', 'Team', 'Kontakt'],
      ctaText: 'Offerte anfragen',
    },
    hero: {
      title: 'Saubere Arbeit. Saubere Abnahme.',
      subtitle:
        'Planung, Ausführung und Kommunikation – zuverlässig und termintreu.',
      primaryBtn: 'Offerte anfragen',
      secondaryBtn: 'Leistungen',
    },
    trust: {
      items: [
        { value: 'Regional', label: 'Vor Ort' },
        { value: 'Termintreu', label: 'Planbar' },
        { value: 'Sauber', label: 'Dokumentiert' },
        { value: 'Garantie', label: 'Nach Vereinbarung' },
      ],
    },
    services: {
      title: 'Leistungen',
      subtitle: 'Von klein bis gross – sauber umgesetzt.',
      items: [
        {
          icon: '🧱',
          title: 'Umbau & Renovation',
          text: 'Koordination, Umsetzung, Abnahme.',
        },
        {
          icon: '🏠',
          title: 'Service & Reparaturen',
          text: 'Schnelle Hilfe bei Bedarf.',
        },
        {
          icon: '📐',
          title: 'Planung',
          text: 'Klare Offerte und transparenter Ablauf.',
        },
      ],
    },
    process: {
      title: 'So läuft es ab',
      subtitle: '',
      steps: [
        {
          num: '1',
          title: 'Besichtigung',
          text: 'Kurz vor Ort, Umfang klären.',
        },
        {
          num: '2',
          title: 'Offerte',
          text: 'Transparent, nachvollziehbar.',
        },
        {
          num: '3',
          title: 'Umsetzung',
          text: 'Termine, Kommunikation, Qualität.',
        },
        { num: '4', title: 'Abnahme', text: 'Sauber dokumentiert.' },
      ],
    },
    benefits: {
      title: 'Warum wir?',
      subtitle: '',
      items: [
        {
          title: 'Transparente Offerten',
          text: 'Klare Positionen und nachvollziehbare Schritte.',
        },
        {
          title: 'Saubere Kommunikation',
          text: 'Sie wissen, was wann passiert.',
        },
        {
          title: 'Qualitätsfokus',
          text: 'Saubere Abnahme und Dokumentation.',
        },
      ],
    },
    team: {
      title: 'Unser Team',
      subtitle: 'Erfahrung und Zuverlässigkeit.',
      members: [
        {
          name: 'Hans Muster',
          role: 'Geschäftsführer & Meister',
          image: '',
          bio: 'Eidg. diplomierter Meister mit über 30 Jahren Erfahrung im Handwerk.',
        },
        {
          name: 'Martin Weber',
          role: 'Projektleiter',
          image: '',
          bio: 'Koordination und Ausführung von Umbauten und Renovationen.',
        },
      ],
    },
    testimonials: {
      title: 'Kundenstimmen',
      items: [
        {
          quote: 'Top Arbeit und klare Kommunikation.',
          author: 'Kundin',
          role: 'Privat',
        },
        {
          quote: 'Badezimmer-Renovation termingerecht und sauber abgeschlossen. Sehr zufrieden.',
          author: 'Markus S.',
          role: 'Eigenheimbesitzer',
        },
        {
          quote: 'Faire Offerte, keine versteckten Kosten und eine tadellose Ausführung.',
          author: 'Christine B.',
          role: 'Mieterin',
        },
        {
          quote: 'Wir beauftragen die Firma seit Jahren — immer zuverlässig und pünktlich.',
          author: 'Hausverwaltung Müller',
          role: 'Liegenschaftsverwaltung',
        },
      ],
    },
    faq: {
      title: 'FAQ',
      items: [
        {
          question: 'Wie schnell erhalte ich eine Offerte?',
          answer:
            'Nach Besichtigung und Umfangs-Klärung erstellen wir zeitnah eine Offerte.',
        },
        {
          question: 'Übernehmen Sie auch kleinere Reparaturen?',
          answer: 'Ja, wir sind auch für kleinere Arbeiten da — von der tropfenden Leitung bis zum kaputten Türschloss. Kein Auftrag ist zu klein.',
        },
        {
          question: 'Geben Sie Garantie auf Ihre Arbeit?',
          answer: 'Ja, je nach Auftragsart gewähren wir 1 bis 5 Jahre Garantie. Die genauen Bedingungen sind in der Offerte klar geregelt.',
        },
      ],
    },
    cta: {
      title: 'Offerte anfragen',
      subtitle: 'Schnell und unverbindlich.',
    },
    footer: {
      companyName: 'Handwerk Muster',
      tagline: 'Handwerkliche Qualität in Ihrer Region.',
    },
  },
});
